export default {
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGOUT: 'USER_LOGOUT',

  REQUEST_USER_PASSWORD_RESET: 'REQUEST_USER_PASSWORD_RESET',
  USER_PASSWORD_RESET_SUCCESS: 'USER_PASSWORD_RESET_SUCCESS',
  USER_PASSWORD_RESET_FAILURE: 'USER_PASSWORD_RESET_FAILURE',

  REQUEST_USER_TOKEN_PERSIST: 'REQUEST_USER_TOKEN_PERSIST',
  USER_TOKEN_PERSIST_SUCCESS: 'USER_TOKEN_PERSIST_SUCCESS',
  USER_TOKEN_PERSIST_FAILURE: 'USER_TOKEN_PERSIST_FAILURE',

  REQUEST_USER_ORGANIZATIONS: 'REQUEST_USER_ORGANIZATIONS',
  USER_ORGANIZATIONS_GET_SUCCESS: 'USER_ORGANIZATIONS_GET_SUCCESS',
  USER_ORGANIZATIONS_GET_FAILURE: 'USER_ORGANIZATIONS_GET_FAILURE',

  REQUEST_TENANT_CREATION: 'REQUEST_TENANT_CREATION',
  CREATE_TENANT_SUCCESS: 'CREATE_TENANT_SUCCESS',
  CREATE_TENANT_FAILURE: 'CREATE_TENANT_FAILURE',

  REQUEST_EMAIL_VERIFICATION_LINK: 'REQUEST_EMAIL_VERIFICATION_LINK',
  GET_EMAIL_VERIFICATION_LINK_SUCCESS: 'GET_EMAIL_VERIFICATION_LINK_SUCCESS',
  GET_EMAIL_VERIFICATION_LINK_FAILURE: 'GET_EMAIL_VERIFICATION_LINK_FAILURE',

  REQUEST_USER_AUTH_TOKEN_EXCHANGE: 'REQUEST_USER_AUTH_TOKEN_EXCHANGE',
  USER_AUTH_TOKEN_EXCHANGE_SUCCESS: 'USER_TOKEN_PERSIST_SUCCESS',
  USER_AUTH_TOKEN_EXCHANGE_FAILURE: 'USER_AUTH_TOKEN_EXCHANGE_FAILURE',

  REQUEST_USER_REGISTER: 'REQUEST_USER_REGISTER',
  USER_REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
  USER_REGISTER_FAILURE: 'USER_REGISTER_FAILURE',

  USER_FORGOT_PASSWORD: 'USER_FORGOT_PASSWORD',
  USER_CHANGE_PASSWORD: 'USER_CHANGE_PASSWORD',
  USER_UPDATE_PROFILE: 'USER_UPDATE_PROFILE',
  USER_VERIFY_EMAIL: 'USER_VERIFY_EMAIL',

  LOCATION_CHANGE: '@@router/LOCATION_CHANGE',
  TOGGLE_DASHBOARDS: 'TOGGLE_DASHBOARDS',

  REQUEST_POOL_ATTRIBUTES: 'REQUEST_POOL_ATTRIBUTES',
  POOL_ATTRIBUTES_GET_SUCCESS: 'POOL_ATTRIBUTES_GET_SUCCESS',
  POOL_ATTRIBUTES_GET_FAILURE: 'POOL_ATTRIBUTES_GET_FAILURE',

  REQUEST_LOGGED_IN_USER: 'REQUEST_LOGGED_IN_USER',
  LOGGED_IN_USER_GET_SUCCESS: 'LOGGED_IN_USER_GET_SUCCESS',
  LOGGED_IN_USER_GET_FAILURE: 'LOGGED_IN_USER_GET_FAILURE',
  LOGGED_IN_USER_FORBIDDEN: 'LOGGED_IN_USER_FORBIDDEN',
  LOADING_USER: 'LOADING_USER',
  TRIGGER_LOGOUT: 'TRIGGER_LOGOUT',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',

  MAP_LOCATION_SELECTOR: 'MAP_LOCATION_SELECTOR',
  CANCEL_MAP_LOCATION_SELECTOR: 'CANCEL_MAP_LOCATION_SELECTOR',
  SET_MAP_LOCATION_POINT: 'SET_MAP_LOCATION_POINT',
  SET_MAP_LOCATION_TYPE_ID: 'SET_MAP_LOCATION_TYPE_ID',
  EDIT_MAP_LOCATION_POINT: 'EDIT_MAP_LOCATION_POINT',
  RESET_MAP_LOCATION_POINT: 'RESET_MAP_LOCATION_POINT',
  SET_MAP_CENTER: 'SET_MAP_CENTER',

  REQUEST_POLL_MAP_USERS: 'REQUEST_POLL_MAP_USERS',
  REQUEST_STOP_POLL_MAP_USERS: 'REQUEST_STOP_POLL_MAP_USERS',

  UPDATE_WORK_ORDERS_INPUT: 'UPDATE_WORK_ORDERS_INPUT',

  TOKEN_SET: 'TOKEN_SET',
  TOKEN_REFRESH: 'TOKEN_REFRESH',

  REQUEST_FORM_TEMPLATES: 'REQUEST_FORM_TEMPLATES',
  GET_FORM_TEMPLATES_SUCCESS: 'GET_FORM_TEMPLATES_SUCCESS',
  GET_FORM_TEMPLATES_FAILURE: 'GET_FORM_TEMPLATES_FAILURE',
  GET_FORM_TEMPLATES_TOTAL_SUCCESS: 'GET_FORM_TEMPLATES_TOTAL_SUCCESS',

  REQUEST_FORM_TEMPLATE_DELETE: 'REQUEST_FORM_TEMPLATE_DELETE',
  DELETE_FORM_TEMPLATE_SUCCESS: 'DELETE_FORM_TEMPLATE_SUCCESS',
  DELETE_FORM_TEMPLATE_FAILURE: 'DELETE_FORM_TEMPLATE_FAILURE',

  REQUEST_FORM_TEMPLATE: 'REQUEST_FORM_TEMPLATE',
  FORM_TEMPLATE_GET_SUCCESS: 'FORM_TEMPLATE_GET_SUCCESS',
  FORM_TEMPLATE_GET_FAILURE: 'FORM_TEMPLATE_GET_FAILURE',

  REQUEST_CLEAR_FORM_TEMPLATE: 'REQUEST_CLEAR_FORM_TEMPLATE',
  FORM_TEMPLATE_CLEAR_SUCCESS: 'FORM_TEMPLATE_CLEAR_SUCCESS',

  REQUEST_UPDATE_FORM_TEMPLATE: 'REQUEST_UPDATE_FORM_TEMPLATE',
  REQUEST_UPDATE_FORM_TEMPLATE_TEXT: 'REQUEST_UPDATE_FORM_TEMPLATE_TEXT',
  UPDATE_FORM_TEMPLATE_SUCCESS: 'UPDATE_FORM_TEMPLATE_SUCCESS',
  UPDATE_FORM_TEMPLATE_FAILURE: 'UPDATE_FORM_TEMPLATE_FAILURE',

  REQUEST_CREATE_FORM_TEMPLATE: 'REQUEST_CREATE_FORM_TEMPLATE',
  CREATE_FORM_TEMPLATE_SUCCESS: 'CREATE_FORM_TEMPLATE_SUCCESS',
  CREATE_FORM_TEMPLATE_FAILURE: 'CREATE_FORM_TEMPLATE_FAILURE',

  REQUEST_DUPLICATE_FORM_TEMPLATE: 'REQUEST_DUPLICATE_FORM_TEMPLATE',
  DUPLICATE_FORM_TEMPLATE_SUCCESS: 'DUPLICATE_FORM_TEMPLATE_SUCCESS',
  DUPLICATE_FORM_TEMPLATE_FAILURE: 'DUPLICATE_FORM_TEMPLATE_FAILURE',

  REQUEST_RENAME_FORM_TEMPLATE: 'REQUEST_RENAME_FORM_TEMPLATE',
  RENAME_FORM_TEMPLATE_SUCCESS: 'RENAME_FORM_TEMPLATE_SUCCESS',
  RENAME_FORM_TEMPLATE_FAILURE: 'RENAME_FORM_TEMPLATE_FAILURE',

  REQUEST_FORM_INSTANCE: 'REQUEST_FORM_INSTANCE',
  GET_FORM_INSTANCE_SUCCESS: 'GET_FORM_INSTANCE_SUCCESS',
  GET_FORM_INSTANCE_FAILURE: 'GET_FORM_INSTANCE_FAILURE',

  REQUEST_CLEAR_FORM_INSTANCE: 'REQUEST_CLEAR_FORM_INSTANCE',
  CLEAR_FORM_INSTANCE_SUCCESS: 'CLEAR_FORM_INSTANCE_SUCCESS',

  REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_FIELD:
    'REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_FIELD',
  UPDATE_FORM_INSTANCE_FIELD_SUCCESS: 'UPDATE_FORM_INSTANCE_FIELD_SUCCESS',
  UPDATE_FORM_INSTANCE_FIELD_FAILURE: 'UPDATE_FORM_INSTANCE_FIELD_FAILURE',

  UPDATE_FORM_INSTANCE_ATTRIBUTE_SUCCESS:
    'UPDATE_FORM_INSTANCE_ATTRIBUTE_SUCCESS',
  UPDATE_FORM_INSTANCE_ATTRIBUTE_FAILURE:
    'UPDATE_FORM_INSTANCE_ATTRIBUTE_FAILURE',
  REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_ATTRIBUTE:
    'REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_ATTRIBUTE',

  UPDATE_FORM_INSTANCE_FHWA_SUCCESS: 'UPDATE_FORM_INSTANCE_FHWA_SUCCESS',
  UPDATE_FORM_INSTANCE_FHWA_FAILURE: 'UPDATE_FORM_INSTANCE_FHWA_FAILURE',
  REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_FHWA:
    'REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_FHWA',

  REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_CI:
    'REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_CI',
  UPDATE_FORM_INSTANCE_CI_SUCCESS: 'UPDATE_FORM_INSTANCE_CI_SUCCESS',
  UPDATE_FORM_INSTANCE_CI_FAILURE: 'UPDATE_FORM_INSTANCE_CI_FAILURE',

  REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_PCI:
    'REQUEST_PROGRESSIVE_UPDATE_FORM_INSTANCE_PCI',
  UPDATE_FORM_INSTANCE_PCI_SUCCESS: 'UPDATE_FORM_INSTANCE_PCI_SUCCESS',
  UPDATE_FORM_INSTANCE_PCI_FAILURE: 'UPDATE_FORM_INSTANCE_PCI_FAILURE',

  REQUEST_DELETE_FORM_INSTANCE: 'REQUEST_DELETE_FORM_INSTANCE',
  DELETE_FORM_INSTANCE_SUCCESS: 'DELETE_FORM_INSTANCE_SUCCESS',
  DELETE_FORM_INSTANCE_FAILURE: 'DELETE_FORM_INSTANCE_FAILURE',

  REQUEST_ADD_FORM_INSTANCE_MEDIA: 'REQUEST_ADD_FORM_INSTANCE_MEDIA',
  ADD_FORM_INSTANCE_MEDIA_SUCCESS: 'ADD_FORM_INSTANCE_MEDIA_SUCCESS',
  ADD_FORM_INSTANCE_MEDIA_FAILURE: 'ADD_FORM_INSTANCE_MEDIA_FAILURE',

  REQUEST_DELETE_FORM_INSTANCE_MEDIA: 'REQUEST_DELETE_FORM_INSTANCE_MEDIA',
  DELETE_FORM_INSTANCE_MEDIA_SUCCESS: 'DELETE_FORM_INSTANCE_MEDIA_SUCCESS',
  DELETE_FORM_INSTANCE_MEDIA_FAILURE: 'DELETE_FORM_INSTANCE_MEDIA_FAILURE',

  REQUEST_INVENTORY_SCHEMAS: 'REQUEST_INVENTORY_SCHEMAS',
  GET_INVENTORY_SCHEMAS_SUCCESS: 'GET_INVENTORY_SCHEMAS_SUCCESS',
  GET_INVENTORY_SCHEMAS_FAILURE: 'GET_INVENTORY_SCHEMAS_FAILURE',

  REQUEST_SCHEMA_BY_IDS: 'REQUEST_SCHEMA_BY_IDS',
  GET_SCHEMA_BY_IDS_SUCCESS: 'GET_SCHEMA_BY_IDS_SUCCESS',
  GET_SCHEMA_BY_IDS_FAILURE: 'GET_SCHEMA_BY_IDS_FAILURE',

  REQUEST_INVENTORY_SCHEMA: 'REQUEST_INVENTORY_SCHEMA',
  REQUEST_INVENTORY_SCHEMA_BY_ASSET_ID: 'REQUEST_INVENTORY_SCHEMA_BY_ASSET_ID',
  GET_INVENTORY_SCHEMA_SUCCESS: 'GET_INVENTORY_SCHEMA_SUCCESS',
  GET_INVENTORY_SCHEMA_FAILURE: 'GET_INVENTORY_SCHEMA_FAILURE',

  REQUEST_INVENTORY_SCHEMA_TREE_NODE: 'REQUEST_INVENTORY_SCHEMA_TREE_NODE',
  GET_INVENTORY_SCHEMA_TREE_NODE_SUCCESS:
    'GET_INVENTORY_SCHEMA_TREE_NODE_SUCCESS',
  GET_INVENTORY_SCHEMA_TREE_NODE_FAILURE:
    'GET_INVENTORY_SCHEMA_TREE_NODE_FAILURE',

  REQUEST_INVENTORY_SCHEMA_CLEAR: 'REQUEST_INVENTORY_SCHEMA_CLEAR',
  CLEAR_INVENTORY_SCHEMA_SUCCESS: 'CLEAR_INVENTORY_SCHEMA_SUCCESS',

  REQUEST_SCHEMA_TREE: 'REQUEST_SCHEMA_TREE',
  GET_SCHEMA_TREE_SUCCESS: 'GET_SCHEMA_TREE_SUCCESS',
  GET_SCHEMA_TREE_FAILURE: 'GET_SCHEMA_TREE_FAILURE',

  REQUEST_SCHEMA_DETAIL: 'REQUEST_SCHEMA_DETAIL',
  GET_SCHEMA_DETAIL_SUCCESS: 'GET_SCHEMA_DETAIL_SUCCESS',
  GET_SCHEMA_DETAIL_FAILURE: 'GET_SCHEMA_DETAIL_FAILURE',

  REQUEST_SCHEMA_TREE_UPDATE: 'REQUEST_SCHEMA_TREE_UPDATE',
  UPDATE_SCHEMA_TREE_SUCCESS: 'UPDATE_SCHEMA_TREE_SUCCESS',
  UPDATE_SCHEMA_TREE_FAILURE: 'UPDATE_SCHEMA_TREE_FAILURE',

  REQUEST_INVENTORY_FILTER_CATEGORY_TREE_NODE:
    'REQUEST_INVENTORY_FILTER_CATEGORY_TREE_NODE',
  GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS:
    'GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS',
  GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE:
    'GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE',

  CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE:
    'CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE',
  CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS:
    'CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS',
  CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE:
    'CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE',

  REQUEST_CATEGORY_TREE_UPDATE: 'REQUEST_CATEGORY_TREE_UPDATE',
  UPDATE_CATEGORY_TREE_SUCCESS: 'UPDATE_CATEGORY_TREE_SUCCESS',
  UPDATE_CATEGORY_TREE_FAILURE: 'UPDATE_CATEGORY_TREE_FAILURE',

  REQUEST_CREATE_CATEGORY: 'REQUEST_CREATE_CATEGORY',
  CREATE_CATEGORY_SUCCESS: 'CREATE_CATEGORY_SUCCESS',
  CREATE_CATEGORY_FAILURE: 'CREATE_CATEGORY_FAILURE',

  REQUEST_FULL_CATEGORY_TREE: 'REQUEST_FULL_CATEGORY_TREE',
  GET_FULL_CATEGORY_TREE_SUCCESS: 'GET_FULL_CATEGORY_TREE_SUCCESS',
  GET_FULL_CATEGORY_TREE_FAILURE: 'GET_FULL_CATEGORY_TREE_FAILURE',

  REQUEST_INVENTORY_CATEGORIES: 'REQUEST_INVENTORY_CATEGORIES',
  GET_INVENTORY_CATEGORIES_SUCCESS: 'GET_INVENTORY_CATEGORIES_SUCCESS',
  GET_INVENTORY_CATEGORIES_FAILURE: 'GET_INVENTORY_CATEGORIES_FAILURE',

  REQUEST_INVENTORY_ASSETS: 'REQUEST_INVENTORY_ASSETS',
  GET_INVENTORY_ASSETS_SUCCESS: 'GET_INVENTORY_ASSETS_SUCCESS',
  GET_INVENTORY_ASSETS_FAILURE: 'GET_INVENTORY_ASSETS_FAILURE',

  REQUEST_INVENTORY_ASSETS_FILTER: 'REQUEST_INVENTORY_ASSETS_FILTER',
  GET_INVENTORY_ASSETS_FILTER_SUCCESS: 'GET_INVENTORY_ASSETS_FILTER_SUCCESS',
  GET_INVENTORY_ASSETS_FILTER_FAILURE: 'GET_INVENTORY_ASSETS_FILTER_FAILURE',

  REQUEST_ROOT_ASSET_BATCH_CREATE_FHWA: 'REQUEST_ROOT_ASSET_BATCH_CREATE_FHWA',
  CREATE_ROOT_ASSET_BATCH_FHWA_SUCCESS: 'CREATE_ROOT_ASSET_BATCH_FHWA_SUCCESS',
  CREATE_ROOT_ASSET_BATCH_FHWA_FAILURE: 'CREATE_ROOT_ASSET_BATCH_FHWA_FAILURE',

  REQUEST_FHWA_ELEMENT_DELETE: 'REQUEST_FHWA_ELEMENT_DELETE',
  DELETE_FHWA_ELEMENT_SUCCESS: 'DELETE_FHWA_ELEMENT_SUCCESS',
  DELETE_FHWA_ELEMENT_FAILURE: 'DELETE_FHWA_ELEMENT_FAILURE',

  REQUEST_ROOT_INVENTORY_ASSET_DELETION:
    'REQUEST_ROOT_INVENTORY_ASSET_DELETION',
  ROOT_INVENTORY_ASSET_DELETION_SUCCESS:
    'ROOT_INVENTORY_ASSET_DELETION_SUCCESS',
  ROOT_INVENTORY_ASSET_DELETION_FAILURE:
    'ROOT_INVENTORY_ASSET_DELETION_FAILURE',

  REQUEST_UPLOAD_FILES: 'REQUEST_UPLOAD_FILES',
  UPLOAD_FILES_SUCCESS: 'UPLOAD_FILES_SUCCESS',
  UPLOAD_FILES_FAILURE: 'UPLOAD_FILES_FAILURE',

  REQUEST_DOWNLOAD_FILES: 'REQUEST_DOWNLOAD_FILES',
  DOWNLOAD_FILES_SUCCESS: 'DOWNLOAD_FILES_SUCCESS',
  DOWNLOAD_FILES_FAILURE: 'DOWNLOAD_FILES_FAILURE',

  REQUEST_MEDIA: 'REQUEST_MEDIA',
  GET_MEDIA_SUCCESS: 'GET_MEDIA_SUCCESS',
  GET_MEDIA_FAILURE: 'GET_MEDIA_FAILURE',
  GET_MEDIA_TOTAL_SUCCESS: 'GET_MEDIA_TOTAL_SUCCESS',

  REQUEST_PATCH_MEDIA: 'REQUEST_PATCH_MEDIA',
  PATCH_MEDIA_SUCCESS: 'PATCH_MEDIA_SUCCESS',
  PATCH_MEDIA_FAILURE: 'PATCH_MEDIA_FAILURE',

  REQUEST_DELETE_MEDIA: 'REQUEST_DELETE_MEDIA',
  DELETE_MEDIA_SUCCESS: 'DELETE_MEDIA_SUCCESS',
  DELETE_MEDIA_FAILURE: 'DELETE_MEDIA_FAILURE',

  REQUEST_MEDIA_FOLDER_TREE: 'REQUEST_MEDIA_FOLDER_TREE',
  GET_MEDIA_FOLDER_TREE_SUCCESS: 'GET_MEDIA_FOLDER_TREE_SUCCESS',
  GET_MEDIA_FOLDER_TREE_FAILURE: 'GET_MEDIA_FOLDER_TREE_FAILURE',

  REQUEST_MEDIA_FOLDER_TREE_UPDATE: 'REQUEST_MEDIA_FOLDER_TREE_UPDATE',
  UPDATE_MEDIA_FOLDER_TREE_SUCCESS: 'UPDATE_MEDIA_FOLDER_TREE_SUCCESS',
  UPDATE_MEDIA_FOLDER_TREE_FAILURE: 'UPDATE_MEDIA_FOLDER_TREE_FAILURE',

  REQUEST_MEDIA_TOTALS: 'REQUEST_MEDIA_TOTALS',
  GET_MEDIA_TOTALS_SUCCESS: 'GET_MEDIA_TOTALS_SUCCESS',
  GET_MEDIA_TOTALS_FAILURE: 'GET_MEDIA_TOTALS_FAILURE',

  REQUEST_MEDIA_FOLDERS: 'REQUEST_MEDIA_FOLDERS',
  GET_MEDIA_FOLDERS_SUCCESS: 'GET_MEDIA_FOLDERS_SUCCESS',
  GET_MEDIA_FOLDERS_FAILURE: 'GET_MEDIA_FOLDERS_FAILURE',

  REQUEST_MEDIA_FOLDER_UPDATE: 'REQUEST_MEDIA_FOLDER_UPDATE',
  UPDATE_MEDIA_FOLDER_SUCCESS: 'UPDATE_MEDIA_FOLDER_SUCCESS',
  UPDATE_MEDIA_FOLDER_FAILURE: 'UPDATE_MEDIA_FOLDER_FAILURE',

  REQUEST_MEDIA_FOLDER_CREATE: 'REQUEST_MEDIA_FOLDER_CREATE',
  CREATE_MEDIA_FOLDER_SUCCESS: 'CREATE_MEDIA_FOLDER_SUCCESS',
  CREATE_MEDIA_FOLDER_FAILURE: 'CREATE_MEDIA_FOLDER_FAILURE',

  REQUEST_MEDIA_FOLDER_DELETE: 'REQUEST_MEDIA_FOLDER_DELETE',
  DELETE_MEDIA_FOLDER_SUCCESS: 'DELETE_MEDIA_FOLDER_SUCCESS',
  DELETE_MEDIA_FOLDER_FAILURE: 'DELETE_MEDIA_FOLDER_FAILURE',

  REQUEST_WORK_TEMPLATES: 'REQUEST_WORK_TEMPLATES',
  GET_WORK_TEMPLATES_SUCCESS: 'GET_WORK_TEMPLATES_SUCCESS',
  GET_WORK_TEMPLATES_FAILURE: 'GET_WORK_TEMPLATES_FAILURE',
  GET_WORK_TEMPLATES_TOTAL_SUCCESS: 'GET_WORK_TEMPLATES_TOTAL_SUCCESS',

  UPDATE_WORK_TEMPLATES_VIEW: 'UPDATE_WORK_TEMPLATES_VIEW',

  REQUEST_HISTORY: 'REQUEST_HISTORY',
  GET_HISTORY_SUCCESS: 'GET_HISTORY_SUCCESS',
  GET_HISTORY_FAILURE: 'GET_HISTORY_FAILURE',

  REQUEST_EXPORT_TEMPLATES: 'REQUEST_EXPORT_TEMPLATES',
  GET_EXPORT_TEMPLATES_SUCCESS: 'GET_EXPORT_TEMPLATES_SUCCESS',
  GET_EXPORT_TEMPLATES_FAILURE: 'GET_EXPORT_TEMPLATES_FAILURE',

  REQUEST_EXPORT_TEMPLATE_DETAIL: 'REQUEST_EXPORT_TEMPLATE_DETAIL',
  GET_EXPORT_TEMPLATE_DETAIL_SUCCESS: 'GET_EXPORT_TEMPLATE_DETAIL_SUCCESS',
  GET_EXPORT_TEMPLATE_DETAIL_FAILURE: 'GET_EXPORT_TEMPLATE_DETAIL_FAILURE',

  REQUEST_EXPORT_TEMPLATE_CREATE: 'REQUEST_EXPORT_TEMPLATE_CREATE',
  CREATE_EXPORT_TEMPLATE_SUCCESS: 'CREATE_EXPORT_TEMPLATE_SUCCESS',
  CREATE_EXPORT_TEMPLATE_FAILURE: 'CREATE_EXPORT_TEMPLATE_FAILURE',

  REQUEST_EXPORT_TEMPLATE_DELETE: 'REQUEST_EXPORT_TEMPLATE_DELETE',
  DELETE_EXPORT_TEMPLATE_SUCCESS: 'DELETE_EXPORT_TEMPLATE_SUCCESS',
  DELETE_EXPORT_TEMPLATE_FAILURE: 'DELETE_EXPORT_TEMPLATE_FAILURE',

  REQUEST_EXPORT_TEMPLATE_UPDATE: 'REQUEST_EXPORT_TEMPLATE_UPDATE',
  UPDATE_EXPORT_TEMPLATE_SUCCESS: 'UPDATE_EXPORT_TEMPLATE_SUCCESS',
  UPDATE_EXPORT_TEMPLATE_FAILURE: 'UPDATE_EXPORT_TEMPLATE_FAILURE',

  REQUEST_ADD_EXPORT_TEMPLATE_SCHEMA: 'REQUEST_ADD_EXPORT_TEMPLATE_SCHEMA',
  ADD_EXPORT_TEMPLATE_SCHEMA_SUCCESS: 'ADD_EXPORT_TEMPLATE_SCHEMA_SUCCESS',
  ADD_EXPORT_TEMPLATE_SCHEMA_FAILURE: 'ADD_EXPORT_TEMPLATE_SCHEMA_FAILURE',

  REQUEST_DELETE_EXPORT_TEMPLATE_SCHEMA:
    'REQUEST_DELETE_EXPORT_TEMPLATE_SCHEMA',
  DELETE_EXPORT_TEMPLATE_SCHEMA_SUCCESS:
    'DELETE_EXPORT_TEMPLATE_SCHEMA_SUCCESS',
  DELETE_EXPORT_TEMPLATE_SCHEMA_FAILURE:
    'DELETE_EXPORT_TEMPLATE_SCHEMA_FAILURE',

  REQUEST_UPDATE_EXPORT_TEMPLATE_SCHEMA:
    'REQUEST_UPDATE_EXPORT_TEMPLATE_SCHEMA',
  UPDATE_EXPORT_TEMPLATE_SCHEMA_SUCCESS:
    'UPDATE_EXPORT_TEMPLATE_SCHEMA_SUCCESS',
  UPDATE_EXPORT_TEMPLATE_SCHEMA_FAILURE:
    'UPDATE_EXPORT_TEMPLATE_SCHEMA_FAILURE',

  UPDATE_WORK_VALIDATIONS: 'UPDATE_WORK_VALIDATIONS',

  UPDATE_TEAM_NAVIGATION: 'UPDATE_TEAM_NAVIGATION',

  UPDATE_INVENTORY_NAVIGATION: 'UPDATE_INVENTORY_NAVIGATION',

  SET_ARCGIS_LAYER_DATA: 'SET_ARCGIS_LAYER_DATA',
  REMOVE_ARCGIS_LAYER_DATA: 'REMOVE_ARCGIS_LAYER_DATA',
};
